import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class RoleService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/roles', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/role/{id}', { id: id }), params);
	}

	async update(id, data, params) {
		return this.api.put(urlReplace('/secure/role/{id}', { id: id }), data, params);
	}
}